import React, { useCallback, useEffect, useMemo, useState } from 'react';

import ImageSet from '~/components/Gallery/ImageSet';
import Loading from '~/components/Loading';
import Pagination from '~/components/Pagination';

import { useAuth } from '~/modules/auth/useAuth';
import { getVisibilitySettings } from '~/modules/contentVisibility';
import {
  queryKeys as galleryQueryKeys,
  useGalleryFolder,
} from '~/modules/gallery/queries';

import { useAppSelector } from '~/hooks/redux';
import { getQueryClient } from '~/queryClient';

import PasswordPrompt from './PasswordPrompt';

export default function Folder({ id }: { id: string }) {
  const [promptingPassword, setPromptingPassword] = useState(false);
  const [password, setPassword] = useState('');

  const [page, setPage] = useState(1);
  const { currentUser } = useAuth();
  const adultToggleState = useAppSelector(getVisibilitySettings);

  const { data, isLoading } = useGalleryFolder(id, page, password);

  useEffect(() => {
    setPage(1);
  }, [id]);

  /** @todo Ideally, this would be done in the mutation also exported from a central queries file. */
  const reloadData = useCallback(() => {
    getQueryClient().invalidateQueries({
      queryKey: galleryQueryKeys.galleryFolder(id, page, password),
    });
  }, [id, page, password]);

  const needsPagination = useMemo(() => {
    return data && data?.meta?.total_pages > 1;
  }, [data]);

  if ((isLoading || !data) && !promptingPassword) {
    return <Loading />;
  }

  if (promptingPassword) {
    return (
      <PasswordPrompt
        handleSubmit={(values) => {
          setPassword(values.password);
          setPromptingPassword(false);
        }}
      />
    );
  }

  return (
    <div>
      {needsPagination && (
        <Pagination
          page={page}
          totalPages={data?.meta.total_pages!}
          onChange={setPage}
        />
      )}

      {isLoading ? (
        <Loading />
      ) : (
        <ImageSet
          onDelete={reloadData}
          currentUser={currentUser}
          images={data!.data}
          adultToggleState={adultToggleState}
        />
      )}

      {needsPagination && (
        <Pagination
          page={page}
          totalPages={data?.meta.total_pages!}
          onChange={setPage}
        />
      )}
    </div>
  );
}
